import { and, reads } from '@ember/object/computed';
import { service } from '@ember/service';
import Route from '@ember/routing/route';
import classic from 'ember-classic-decorator';

@classic
export default class SiteLegalAgreementsRoute extends Route {
  @service router;
  @service session;

  @reads('session.currentClientAccess.eulaAgreementAccepted') eulaAgreementAccepted;
  @reads('session.currentClientAccess.termsOfServiceAgreementAccepted') termsAgreementAccepted;
  @reads('session.currentClientAccess.privacyPolicyAgreementAccepted') privacyAgreementAccepted;
  @and('eulaAgreementAccepted', 'termsAgreementAccepted', 'privacyAgreementAccepted')
  legalAgreementsAccepted;
  @reads('session.isAuthenticated') isAuthenticated;

  beforeModel() {
    if (!this.isAuthenticated) {
      this.router.transitionTo('home');
    } else if (this.legalAgreementsAccepted) {
      this.router.transitionTo('site.home');
    }
  }
}
